import { FC } from 'react';
import { Link, useMatch } from 'react-router-dom';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { Button } from '@savgroup-front-common/primitive/ui/button';

import { MenuItem } from '../AppBarMenu/AppBarMenu.types';

interface AppBarTopNavLinkProps {
  menu: MenuItem;
}

export const AppBarTopNavLink: FC<AppBarTopNavLinkProps> = ({ menu }) => {
  const isActive = useMatch(menu.path);

  return (
    <Button
      asChild
      variant="menu"
      className={
        'relative h-full rounded-none px-4 text-base font-medium ' +
        'after:absolute after:inset-x-0 after:bottom-0 after:h-1 after:rounded-full after:bg-transparent ' +
        'aria-[current=page]:after:bg-surface-primary-default'
      }
    >
      <Link
        to={menu.to}
        aria-current={isActive ? 'page' : undefined}
        data-testid={`appBar_menu_${menu.dataTestId}`}
      >
        <SafeFormattedMessageWithoutSpread message={menu.message} />
      </Link>
    </Button>
  );
};
